export default {"src":"/_next/static/media/desktopImage.0f770751.svg","height":94,"width":123,"blurWidth":0,"blurHeight":0};